import PropTypes from 'prop-types'
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';

import { Box } from '@mui/system';
import { Button, DialogContent } from '@mui/material';
import React from 'react';
import CustomGoogleButton from '../Authentication/GoogleLogin';
import { LOGIN_URL } from '../../config/urls';
export default function PopupSocialShare({onClose, open}) {
  const [showGoogleLoginButton, setShowGoogleLoginButton] = React.useState(false);

  return (
    <Dialog onClose={onClose} open={open}>
      <DialogTitle >You need to Login first</DialogTitle>
      <DialogContent>
        <Box 
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
        >
          <Button
            variant="contained"
            color="primary"
            size="large"
            href={LOGIN_URL}
            sx={{
              fontSize: '1.2rem',
              fontWeight: '600',
            }}
          >
            Login
          </Button>
        </Box>
      </DialogContent>
      
    </Dialog>
  );
}

PopupSocialShare.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};
